import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CompleteEnrollmentReviewMutation = graphql.persisted(
  "CompleteEnrollmentReview",
  graphql(`
    mutation CompleteEnrollmentReview($input: CompleteEnrollmentReviewInput!) {
      completeEnrollmentReview(input: $input) {
        familyEnrollment {
          id state approvedAt
          studentEnrollments { id state person { id firstName lastName } }
          invoices { id status amountCents dueDate key }
        }
        userErrors { message path }
      }
    }
  `)
);

export { CompleteEnrollmentReviewMutation };

export function useCompleteEnrollmentReview() {
  return useMutation(CompleteEnrollmentReviewMutation);
}
